import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProjectStudentMap from "./routes/ProjectStudentMap";
export default store => ({
  path: "assessment",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "project-group" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ProjectStudentMap(store)],
});
